import axios from "axios";
import { frontLog } from "utils/Utils";
import { select_access_token } from "http/TokenConn";
import * as Sentry from "@sentry/react";
import { handleApiError } from "utils/reportError";
import { reportErrorToSentry, SentryNetworkError } from "./SentryNetworkError";

export function Fn_activeAxios(rootStore, { needAuth = false, naverAuth = false } = {}) {
  const { settingStore, layerStore } = rootStore;
  const apiUrl = settingStore.ActiveRestUrl.okgoApi;

  const instance = axios.create({
    baseURL: apiUrl,
    timeout: 25000,
    headers: { 
      "Content-Type": "application/json",
    },
  });
  instance.interceptors.request.use(
    function (config) {
      if (needAuth) {
        config.headers.Authorization = `Bearer ${rootStore.searchStore.getToken}`;
      }
      if (naverAuth) {
        config.headers["X-Naver-Unique-Id"] = rootStore.searchStore.getNaverUniqueId;
      }
      layerStore.setLayerLoadingView(true);
      return config;
    },
    function (error) {
      layerStore.setLayerLoadingView(false);
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    function (response) {
      if (response.status === 200 && response.data.resultCode !== "000") {
        frontLog(rootStore, "WARN", response.config.url, JSON.stringify(response.data));
      }
      layerStore.setLayerLoadingView(false);
      return response;
    },
    function (error) {
      layerStore.setLayerLoadingView(false);

      if (axios.isAxiosError(error)) {
        const apiError = new SentryNetworkError(error);

        // 2. 로컬 로그 기록
        frontLog(rootStore, "ERROR", apiError.config?.url || "Unknown URL", {
          name: apiError.name,
          status: apiError.response?.status,
          message: apiError.message,
        });

        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          return select_access_token(rootStore, false).then(res => {
            if (res) {
              originalRequest.headers.Authorization = "Bearer " + rootStore.searchStore.getToken;
              return axios.request(originalRequest);
            } else {
              reportErrorToSentry(apiError);
              return Promise.reject(apiError);
            }
          });
        }

        // 500번대 에러 또는 응답 없는 네트워크 에러일 때 Sentry로 전송
        if (!apiError.response || apiError.response.status >= 500) {
          reportErrorToSentry(apiError);
        }

        return Promise.reject(apiError);
      } else {
        frontLog(rootStore, "ERROR", "Non-Axios Error", error.message);
        Sentry.captureException(error);
        return Promise.reject(error);
      }
    }
  );

  return instance;
}
